module.exports = __webpack_public_path__ + "static/media/assets.3f59488e.svg";